import React from 'react';
import Layout from '../components/layout/Layout';

const TermsPage = () => {
  return (
    <Layout>
      <section className="pt-32 pb-16 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Terms & Conditions</h1>
          <p className="text-gray-300">Last updated: January 2025</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
          <p className="text-gray-600 mb-6">
            Welcome to STEAM-IE. These Terms and Conditions govern your use of our website, products, and services. 
            By accessing or using STEAM-IE services, you agree to be bound by these terms.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Definitions</h2>
          <p className="text-gray-600 mb-6">
            &ldquo;STEAM-IE&rdquo; refers to our company, website, and all related services. &ldquo;User&rdquo; refers to any individual 
            or entity accessing our services. &ldquo;Services&rdquo; include educational programs, kits, certifications, and 
            online resources.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Use of Services</h2>
          <p className="text-gray-600 mb-6">
            Our services are intended for educational purposes. Users must be at least 18 years old or have 
            parental/guardian consent to use our services. You agree to use our services only for lawful purposes 
            and in accordance with these terms.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Intellectual Property</h2>
          <p className="text-gray-600 mb-6">
            All content, materials, and intellectual property on STEAM-IE are owned by us or our licensors. 
            You may not reproduce, distribute, or create derivative works without our express written permission.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Product Purchases</h2>
          <p className="text-gray-600 mb-6">
            All purchases are subject to availability. Prices are subject to change without notice. 
            Payment must be made in full before product dispatch. We reserve the right to refuse any order.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Certification Programs</h2>
          <p className="text-gray-600 mb-6">
            STEAM-IE certifications are awarded upon successful completion of designated programs. 
            Certificates are non-transferable and may be revoked if obtained through fraudulent means.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Limitation of Liability</h2>
          <p className="text-gray-600 mb-6">
            STEAM-IE shall not be liable for any indirect, incidental, or consequential damages arising 
            from the use of our services. Our total liability shall not exceed the amount paid for the specific service.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Modifications</h2>
          <p className="text-gray-600 mb-6">
            We reserve the right to modify these terms at any time. Continued use of our services after 
            changes constitutes acceptance of the modified terms.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Governing Law</h2>
          <p className="text-gray-600 mb-6">
            These terms shall be governed by the laws of India. Any disputes shall be subject to the 
            exclusive jurisdiction of courts in Ajmer, Rajasthan.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Contact</h2>
          <p className="text-gray-600 mb-6">
            For questions regarding these terms, please contact us at:<br />
            Email: info@steamie.net<br />
            Phone: +91 79966 97777
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default TermsPage;
